import _ from 'underscore';
import Backbone from 'backbone';

/**
 * Base class to all sub FilterAgents<br>
 * Set option value to properties of current instance<br>
 * @extends external:"Backbone.Events"
 */

export class BaseFilterAgent {
  constructor(options = {}) {
    this.options = options;
    _.extend(this, Backbone.Events);
  }

  /**
   * Update filter state by setting current applied filter
   * @param {string} query - Filter query
   * @param {string} name - Filter name
   * @fires BaseFilterAgent#filter-applied
   * @returns {undefined}
   */
  apply(query, name) {
    this.options.filterService.setEditableFilter(query, name);
  }
}
